import {request} from "./request";

export const getUser = queryParams => {
  return request.get({
    path: "/engine/user/info",
    queryParams,
  });
};

export const getUserList = queryParams => {
  return request.get({
    path: "/engine/user/list",
    queryParams,
  });
};

export const createUser = params => {
  return request.post({
    path: "/engine/user/create",
    params,
  });
};

export const updateUser = params => {
  return request.put({
    path: "/engine/user/update",
    params,
  });
};
